export const HOUR_MS = 3600_000;
export const DAY_MS = 24 * HOUR_MS;

/** ~1e12 ms ≈ Sep 2001; unix seconds today ~1.7e9 — treat smaller numbers as seconds. */
export const MS_HEURISTIC_THRESHOLD = 1e11;

export const OVERVIEW_HEATMAP_BUCKET_COUNT = 12;
